import { useContent } from "@/context/ContentContext";
import useMeta from "@/hooks/useMeta";
import { Reveal } from "@/components/site/Reveal";
import { PageHero } from "@/components/site/PageHero";
import { CtaBand } from "@/components/site/CtaBand";

const Row = ({ label, price, testId }) => (
  <div className="flex flex-wrap items-baseline justify-between gap-3 border-b border-[#B9A9D8]/40 py-6 last:border-0" data-testid={testId}>
    <span className="text-lg text-[#22304A]">{label}</span>
    <span className="font-display text-3xl text-[#22304A] sm:text-4xl">{price}</span>
  </div>
);

const Detail = ({ title, text, testId }) => (
  <Reveal className="border-t border-[#B9A9D8]/60 pt-5" data-testid={testId}>
    <h2 className="text-2xl text-[#22304A]">{title}</h2>
    <p className="mt-2 leading-relaxed text-[#22304A]/80">{text}</p>
  </Reveal>
);

export default function Fees() {
  const { content } = useContent();
  const f = content.fees;
  useMeta(
    "Fees · Virtual therapy Ontario",
    "Session fees for virtual psychotherapy with a Registered Social Worker in Ontario: $180 per 50-minute individual session, $215 per 60-minute couples session, free 20-minute phone intro, insurance receipts provided."
  );
  return (
    <>
      <PageHero eyebrow="Fees" title={f.headline} testId="fees-headline" />
      <section className="wrap grid gap-12 pb-12 md:grid-cols-[1.1fr_1fr] md:gap-16">
        <Reveal className="card-soft h-fit px-7 py-2 sm:px-10">
          <Row label={f.consult_label} price={f.consult_price} testId="fee-consult" />
          <Row label={f.session_label} price={f.session_price} testId="fee-session" />
          <Row label={f.couples_label} price={f.couples_price} testId="fee-couples" />
        </Reveal>
        <div className="space-y-8">
          <Detail title="Payment" text={f.payment} testId="fee-payment" />
          <Detail title="Insurance" text={f.insurance} testId="fee-insurance" />
          <Detail title="Sliding scale" text={f.sliding_scale} testId="fee-sliding-scale" />
        </div>
      </section>
      <section className="wrap pb-8">
        <Reveal className="rounded-2xl bg-[#EFEAF6] p-8 sm:p-10" data-testid="fee-cancellation">
          <h2 className="text-2xl text-[#22304A] sm:text-3xl">Cancellation policy</h2>
          <p className="mt-3 max-w-3xl leading-relaxed text-[#22304A]/85">{f.cancellation}</p>
        </Reveal>
      </section>
      <CtaBand title={content.home.final_cta_title} button={content.home.final_cta_button} />
    </>
  );
}
